import React, { useCallback, useEffect, useState ,useRef} from "react";
import Tabelas from "../../../components/SomaStandard/TableComponents/Tabelas";
import SomaTable from "../../../components/SomaStandard/SomaTable";
import { pageList } from "../../../helpers/webHelper";
import SomaPlaceButtonGroup from "../Components/SomaPlaceButtonGroup";
import SomaPlaceService from "../../../Services/SomaPlace/index";
import Modal from "../../../components/Modal";
import Contrato from "../Components/Contrato";
import { parseTimestamp } from "../util/parsers";

const ContratosAceitos = (props) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [contract, setContract] = useState(false);
  const [showContrato, setShowContrato] = useState(false);
  const [result, setResult] = useState(undefined);
  const [data, setData] = useState(null);
  const mounted = useRef(false);


  const getContratosAceitos = useCallback(async () => {
    try {
      let r = await SomaPlaceService.SomaPlace.getContractsSignatures();
      if( mounted.current){
        setData(r.data);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);

  const closeModal = useCallback(() => setShowContrato(false), [setShowContrato]);

  useEffect(() => {
    mounted.current = true;
    setResult(data ? pageList(data, page, rowsPerPage) : []);
    if (data == null) {
      getContratosAceitos();
    }
    return ()=>{ mounted.current = false;}

  }, [contract, data, getContratosAceitos, page, rowsPerPage]);

  return (
    <>
      <SomaTable
        size="small"
        results={result}
        columns={[
          {
            propName: "info",
            component: Tabelas,
            componentProps: {
              colunas: [
                {
                  propName: "info",
                  propText: "Data de Aceite",
                  component: (props) => parseTimestamp(props.line.createdAt).dataHora,
                },
                { propName: "info", propText: "Nome do Contrato", component: (props) => props.line.contract.name },
                { propName: "info", propText: "Versão do Contrato", component: (props) => props.line.contract.version },
                {
                  propName: "info",
                  component: SomaPlaceButtonGroup,
                  componentProps: { setContract, setShowContrato },
                },
              ],

              principal: { propName: "affiliate_code", propText: "" },
            },
          },
        ]}
        {...{
          page,
          setPage,
          rowsPerPage,
          setRowsPerPage,
          total: data ? data.length : 0,
        }}
      />
      <Modal open={showContrato} modalName={"Contrato"} hideButtons onClose={closeModal}>
        <Contrato mode={"view"} contrato={contract} onCancel={closeModal} />
      </Modal>
    </>
  );
};

export default ContratosAceitos;
